import React, { PureComponent } from 'react';
import { Form } from 'antd';
import { language } from '../../../language';
import {
    ColorPicker,
    EntryList,
    UploadPicture,
    FormItemLayout,
    ConfigFormDecorator,
} from '../../tools';
import { NoticeBarTips } from './notice-bar-tips';
import { NoticeBarItem } from './notice-bar-item';

const FormItem = Form.Item;
const MAX_ENTRY_COUNT = 1;
export class noticeBarTransverse extends PureComponent<any> {
    WrapNoticeItem = (props: any) => {
        const { selector } = this.props;
        return <NoticeBarItem key={props.index} {...props} selector={selector} />;
    };
    render() {
        const {
            form: { getFieldDecorator },
            sourceRoot,
            uploadAction,
            linkTypes,
            linkTypeMode,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="editor-notice-bar">
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.NoticeBar.color')}
                >
                    {getFieldDecorator('fontColor')(<ColorPicker />)}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.NoticeBar.backgroundColor')}
                >
                    {getFieldDecorator('backgroundColor')(<ColorPicker />)}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.NoticeBar.icon')}>
                    <div>
                        {getFieldDecorator('leftIcon')(
                            <UploadPicture sourceRoot={sourceRoot} uploadAction={uploadAction} />
                        )}
                        <span>{language.getText('components.NoticeBar.imageSize')}</span>
                    </div>
                </FormItem>
                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapNoticeItem}
                            renderTips={NoticeBarTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">最多添加 1 个通知信息</p>
            </Form>
        );
    }
}
export const NoticeBarTransverse = ConfigFormDecorator(noticeBarTransverse);
